import React, { useState } from "react";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import logo from "../assets/images/slned_logo.svg";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/#about-us" },
    { name: "Team", href: "/#our-team" },
    { name: "Mission", href: "/#our-mission" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <>
      <nav className="bg-white shadow-lg w-full  fixed top-0 z-30">
        <div className="xl:max-w-screen-xl w-11/12 py-0.5 flex justify-between mx-auto items-center">
          {/* Logo */}
          <Link to="/">
            <img src={logo} alt="logo" className="h-[110px] " />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex gap-6 items-center capitalize text-lg font-teacher text-[#005064]">
            {navLinks.map((link) => (
              <HashLink
                key={link.href}
                to={link.href}
                scroll={(el) =>
                  el.scrollIntoView({ behavior: "smooth", block: "start" })
                }
                className="hover:text-[#003d4d] transition"
              >
                {link.name}
              </HashLink>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(true)}
            className="lg:hidden text-[#005064]"
          >
            <MenuOutlinedIcon fontSize="large" />
          </button>
        </div>
      </nav>

      {/* Overlay */}
      <div
        onClick={() => setIsOpen(false)}
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 lg:hidden ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      />

      {/* Offcanvas */}
      <div
        className={`fixed top-0 right-0 h-full w-[280px] bg-white z-50 shadow-2xl transform transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-5 border-b">
          <h2 className="text-xl font-semibold text-[#005064]">Menu</h2>

          <button onClick={() => setIsOpen(false)}>
            <CloseOutlinedIcon fontSize="large" />
          </button>
        </div>

        {/* Links */}
        <div className="flex flex-col p-5">
          {navLinks.map((link) => (
            <HashLink
              key={link.href}
              to={link.href}
              smooth
              onClick={() => setIsOpen(false)}
              className="py-4 border-b text-[#005064] text-lg"
            >
              {link.name}
            </HashLink>
          ))}
        </div>
        <div className="px-5">
          <h3 className="text-xl font-semibold mb-6 text-[#005064]">
            Contact Info
          </h3>
          <div className="space-y-3 ">
            <div className="flex gap-3 text-[#005064] text-lg">
              <LocalPhoneIcon size={20} className="flex-shrink-0" />
              <a href="tel:+919876543210" className=" hover:text-black">
                +91 98765 43210
              </a>
            </div>

            <div className="flex gap-3 text-[#005064] text-lg">
              <EmailOutlinedIcon size={20} className="flex-shrink-0" />
              <a href="mailto:info@slned.com" className=" hover:text-black">
                info@slned.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
